export default "__VITE_ASSET__h5f$_pKa__"